<template>
    <BModal @hidden="resetModal" size="lg" hide-footer ref="evaluationsModal" cancel-variant="outline-secondary" centered title="Realizar cobro"  no-close-on-backdrop>
      <ValidationObserver ref="form">
        <BForm @submit.prevent="">
          <BRow>
            <TextInputValidated vsName="Nombre" :vsModel.sync="evaluation.name" vsLabel="Nombre" vsMd="6" vsRequired vsRules="required" /> 
            <NumberInputValidated vsName="Peso (%)" :vsModel.sync="evaluation.weight" vsLabel="Peso" vsMd="6" vsRequired vsRules="required"/>
            <DatepickerValidated vsName="Fecha inicio" :vsModel.sync="evaluation.start_date" vsMd="6" vsRequired vsRules="required" :vsMin="course.start_date" :vsMax="course.end_date"/>
            <DatepickerValidated vsName="Fecha fin" :vsModel.sync="evaluation.end_date" vsMd="6" vsRequired vsRules="required" :vsMin="evaluation.start_date" :vsMax="course.end_date"/>
            <DatepickerValidated vsName="Fecha evaluación" :vsModel.sync="evaluation.evaluation_date" vsMd="6" vsRequired vsRules="required" :vsMin="evaluation.start_date"/>
          </BRow>
          <BRow>
            <BCol>
              <BButton v-if="addModal" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="onSubmit('add')"> {{ $t("Save") }} </BButton>
              <BButton v-else variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="onSubmit('edit')"> {{ $t("Edit") }} </BButton>
            </BCol>
          </BRow>
        </BForm>
      </ValidationObserver>
    </BModal>
</template>

<script>
import {BForm,  BModal, BFormRadioGroup, BFormGroup,  BFormRadio, BRow, BCol, BInputGroup, BFormInput, BCard, BCardBody, BLink, BImg, BCardText, BButton, BPagination,BInputGroupAppend,BDropdownItem,BDropdown,BSidebar} from 'bootstrap-vue'
import { VueSelect } from 'vue-select'
import { inject, ref, watch } from '@vue/composition-api';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import { addEvaluation, getEvaluation, updateEvaluation } from '@/composables/evaluationService' 
import { ValidationObserver } from 'vee-validate'
import popups from "@/hooks/popups"

export default {
    components: { BForm, BModal, BCard, BFormGroup, BCardBody, BLink, BImg, BCardText, BButton, BFormRadioGroup, BFormRadio, BRow, BCol, BInputGroup, BInputGroupAppend, BFormInput, BPagination, BDropdownItem, BDropdown, BSidebar, VueSelect, TextInputValidated, DatepickerValidated, CheckboxValidated, NumberInputValidated, ValidationObserver },
    emits: ['refetch-data'] ,
    setup(props, {emit}) {
        const { successToast, errorToast } = popups()
        const form = ref(null)
        const course = inject('course')
        const addModal = inject('addModal')
        const evaluationId = inject('evaluationId')
        const evaluationsModal = inject('evaluationsModal')
        const evaluation = ref({
          course_id: '', 
          name: '', 
          evaluation_date: '', 
          start_date: '', 
          end_date: '', 
          is_evaluable: true, 
          weight: ''
        })

        const onSubmit =  function (action) {
          evaluation.value.course_id = course.value.id 
          form.value.validate().then(success => {
            if(success){
              action=="add" ? createEvaluation(evaluation.value) : editEvaluation(evaluation.value) 
            }
          })
        }
            
        const createEvaluation = async function(newEvaluation) {
          let response = await addEvaluation(newEvaluation)
          if (response.data.success) {
            successToast("Evaluación creada correctamente.")
            resetModal()
            emit("refetch-data")
          } else {
            if (response.data.code) {

              if (response.data.code == "EV_OVERLAP") {
                errorToast("Esta evaluación se solapa con otra. Cambia las fechas.")
              }

              if (response.data.code == "EV_DATE_RANGE") {
                errorToast("Las fechas de la evaluación están fuera de las del curso.")
              }
            } else {
              errorToast("Error creando nota")
            }
          }
        }

        const editEvaluation = async function (editedEvaluation) {
          let response = await updateEvaluation(editedEvaluation)
          if (response.data.success) {
            successToast("Evaluación actualizada correctamente.")
            resetModal()
            emit("refetch-data")
          } else {
            errorToast("Error actualizando evaluación")
          }
        }

        const fetchEvaluation = async function() {
            let response = await getEvaluation(evaluationId.value)
            evaluation.value = response.data.evaluation
            addModal.value = null
        }

        watch(addModal, () => {
          if (addModal.value==false) {
            fetchEvaluation()
          }
        })

        const resetModal = () => {
          evaluationsModal.value.hide()
          evaluation.value = {
            course_id: '', 
            name: '', 
            evaluation_date: '', 
            start_date: '', 
            end_date: '', 
            weight: ''
          }
        }

        return {
            evaluationsModal,
            evaluation,
            form,
            onSubmit,
            addModal,
            resetModal,
            course
        }
    }

}
    
</script>